"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusTypeData = void 0;
var transifex_1 = require("../../transifex");
exports.statusTypeData = {
    new: {
        label: transifex_1.TX_NEW,
        colors: { primary: "#F38804", secondary: "#FFEDD7" },
    },
    in_progress: {
        label: transifex_1.TX_IN_PROGRESS,
        colors: { primary: "#1890FF", secondary: "#C1E1FF" },
    },
    on_hold: {
        label: transifex_1.TX_ON_HOLD,
        colors: { primary: "#F5F5F5", secondary: "#909DA9" },
    },
    open: {
        label: transifex_1.TX_OPEN,
        colors: { primary: "#FF4D4F", secondary: "#FFDCDC" },
    },
    solved: {
        label: transifex_1.TX_SOLVED,
        colors: { primary: "#7CC81B", secondary: "#F4FFB8" },
    },
    created: {
        label: transifex_1.TX_CREATED,
        colors: { primary: "white", secondary: "#FFA940" },
    },
    completed: {
        label: transifex_1.TX_COMPLETED,
        colors: { primary: "white", secondary: "#A0CB26" },
    },
    pending: {
        label: transifex_1.TX_PENDING,
        colors: { primary: "#909DA9", secondary: "#F5F5F5" },
    },
    rejected: {
        label: transifex_1.TX_REJECTED,
        colors: { primary: "#FFDCDC", secondary: "#FF4D4F" },
    },
};
